import React from 'react';
import {
    ModifierDiv,
    LabelContainer,
    ModifierGrid,
    CheckboxLabel,
    ModifierCheckbox,
} from './ModifierStyle';
import formatPrice from '../../../../../../utils/formatPrice';
import { getQuatity } from './ModifierUtil';
import { TextField, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function ModifierCheckBox({ modifier, onChange }) {
    function isDisabled(modifier, isChecked) {
        let max = modifier.max;
        let count = 0;
        for (let option of modifier.options) {
            if (option.checked) {
                count++;
            }
        }
        if (max && max != 0 && count >= max && !isChecked) {
            return true;
        } else {
            return false;
        }
    }

    return (
        <ModifierDiv>
            {modifier.label ? (
                <LabelContainer style={{ paddingBottom: '3px' }}>
                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                        {modifier.label}
                    </Typography>{' '}
                </LabelContainer>
            ) : (
                <LabelContainer style={{ paddingBottom: '3px' }}>
                    <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                        Options
                    </Typography>{' '}
                </LabelContainer>
            )}
            <ModifierGrid>
                {modifier.options &&
                    modifier.options.map(
                        (option, i) =>
                            !option.hide && (
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginBottom: '5px',
                                        justifyContent: 'space-between',
                                    }}
                                >
                                    <CheckboxLabel
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            //marginBottom: '5px',
                                        }}
                                    >
                                        <ModifierCheckbox
                                            type="checkbox"
                                            checked={
                                                option.checked
                                                    ? option.checked
                                                    : false
                                            }
                                            id={option.id}
                                            disabled={
                                                isDisabled(
                                                    modifier,
                                                    option.checked
                                                ) || option.oos
                                            }
                                            name={modifier.id}
                                            onClick={(e) => {
                                                onChange(
                                                    modifier.id,
                                                    option.id,
                                                    !option.checked
                                                );
                                            }}
                                        />
                                        <span>
                                            {option.label}
                                            {option.price
                                                ? ' (+' +
                                                  formatPrice(
                                                      (option.price *
                                                          getQuatity(
                                                              option.quantity
                                                          )) /
                                                          100
                                                  ) +
                                                  ')'
                                                : ''}
                                        </span>
                                        {option.desc && (
                                            <Tooltip
                                                title={option.desc}
                                                placement="top"
                                                arrow
                                                PopperProps={{
                                                    sx: { zIndex: 9999 },
                                                }}
                                            >
                                                <span
                                                    onClick={(e) =>
                                                        e.stopPropagation()
                                                    }
                                                    style={{
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        marginLeft: '5px',
                                                    }}
                                                >
                                                    <InfoOutlinedIcon
                                                        sx={{
                                                            fontSize: 20,
                                                            color: '#757575',
                                                            cursor: 'pointer',
                                                        }}
                                                    />
                                                </span>
                                            </Tooltip>
                                        )}
                                        {option.oos ? (
                                            <span
                                                style={{
                                                    backgroundColor: '#e74c3c',
                                                    color: '#FFFFFF',
                                                    borderRadius: '5px',
                                                }}
                                            >
                                                <b>Sold Out</b>
                                            </span>
                                        ) : (
                                            ''
                                        )}
                                    </CheckboxLabel>
                                    <TextField
                                        size="small"
                                        type="text"
                                        label="Internal Instructions"
                                        disabled={!option.checked}
                                        style={{
                                            width: '50%',
                                            marginLeft: 10,
                                        }}
                                        value={option.internalNotes || ''}
                                        onChange={(e) =>
                                            onChange(
                                                modifier.id,
                                                option.id,
                                                true,
                                                e.target.value
                                            )
                                        }
                                    />
                                </div>
                            )
                    )}
                {isDisabled(modifier, false) && (
                    <Typography variant="body2" color="textSecondary">
                        You have selected the max of {modifier.max} options
                    </Typography>
                )}
            </ModifierGrid>
        </ModifierDiv>
    );
}
